import CryptoJS from 'crypto-js';

export const encrypt = (str: string, secretKey: string): string => {
  return CryptoJS.AES.encrypt(str, secretKey).toString();
};

export const decrypt = (str: string, secretKey: string): string => {
  const bytes = CryptoJS.AES.decrypt(str, secretKey);
  return bytes.toString(CryptoJS.enc.Utf8);
};
